import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import styles from '../styles/menu.module.css';
import { userLogged } from '../userLogged';
import { logoutUser } from '../logoutUser';
import { ArrowBigLeftIcon, LogOutIcon, MenuIcon, Star, X } from 'lucide-react';
import { SwitchMode } from './SwitchMode';
import { urlAPI_Current } from '../config';
import axios from 'axios';
import { verifyUserPaid } from '../verifyUserPaid';
import { stopTracking } from '../tracking';

export function Menu({darkMode, buttonBack, adminUser, photoUpdated, adminPageActually, adminBI }) {
    const navigateTo = useNavigate();
    const [userData, setUserData] = useState([]);
    const [isMenuVisible, setIsMenuVisible] = useState(false); 
    const [isVisibleUpgrade, setIsVisibleUpgrade] = useState(false); 
    const [isVisibleAssign, setIsVisibleAssign] = useState(false); 
    const [planActually, setPlanActually] = useState([]);

    const toggleMenu = () => {
        setIsMenuVisible(!isMenuVisible);
    };

    const handleResize = () => {
      if (window.innerWidth > 550) {
          setIsMenuVisible(false); 
      }
    };

    async function getUserLogged() {
        const user = await userLogged();
        setUserData(user);
    }

    const handleLogout = () => {
        stopTracking();
        localStorage.removeItem('authToken');
        localStorage.removeItem('idThread');
        toast.success('Você saiu da conta!');
        navigateTo('/login');
    };

    useEffect(() => {
        if(photoUpdated){
            getUserLogged();
        }   
    }, [photoUpdated]);

    useEffect(() => {
        const fetchData = async () => {
            const responsePaid = await verifyUserPaid();
            console.log(responsePaid);
            if(responsePaid.success == true){
                console.log(`Plano Atual ${responsePaid.plan}`);
                setPlanActually(responsePaid.plan); 
                setIsVisibleAssign(false)
                setIsVisibleUpgrade(true);
            } else {
                setIsVisibleAssign(true)
                setIsVisibleUpgrade(false);
            }
        };
        fetchData();

        getUserLogged();  
    }, [darkMode]);

    function navigateToHome() {
        navigateTo("/");
    }

    function navigateToBlog() {
        window.open('https://www.example.com', '_blank');
    }

    function navigateToPlans() {
        window.open('https://evoktm.com.br/#plans', '_blank');
    }

    function navigateToContact() {
        window.open('https://evoktm.com.br/#contact', '_blank');
    }

    function navigateToProfile() {
        navigateTo("/profile");
    }

    function navigateToProfileAdmin() {
        navigateTo("/admin/painel");
    }

    function navigateToUpgradePlan(){
        navigateTo("/upgradePlan");
    }

    function navigateToSignPlan(){
        navigateTo("/plans");
    }

    function navigateToReturn(){
        navigateTo(-1);
    }

    function navigateToDashboard(){
        navigateTo("/admin/dashboard");
    }

    function navigateToUsers(){
        navigateTo("/admin/painel");
    }

    function navigateToInvitationsManager(){
        navigateTo("/admin/invitationsManager");
    }

    function navigateToEnterprises(){
        navigateTo("/admin/enterprises");
    }

    return (
        <div className={styles.menu}>
            <div className={styles.menuColumn1}>
                {darkMode ? (
                    <img src="./evokLogoBranca.png" alt="Logo EVOK" className={styles.logo} />   
                ) : (
                    <img src="./evokLogoPreta.png" alt="Logo EVOK" className={styles.logo} />
                )}
            </div>
            <div className={styles.column2}>
                {/* Coluna em branco */}
            </div>
            <div className={`${isMenuVisible ? styles.column3Visible : styles.column3}`}>
                {buttonBack ?  (<strong onClick={navigateToReturn}><ArrowBigLeftIcon /> Voltar</strong>) : null}
                
                {adminUser ? (
                    <strong className="ms-auto" onClick={handleLogout}><LogOutIcon /> Sair</strong>
                ) : (
                    <strong onClick={handleLogout}><LogOutIcon /> Sair</strong>
                )}
                
                {/* 
                {!adminUser && !adminBI ? (
                    <div>
                        {isVisibleAssign ? <p onClick={navigateToSignPlan} className={styles.upgradePlan}><Star /> | Upgrade no Plano</p> : null}
                    </div>
                ): null} */}

                {adminUser ? (
                <div>
                    {adminPageActually == 'dashboard' ? (<strong style={{ color: '#1B82FC' }} >Dashboard</strong>) : (<strong onClick={navigateToDashboard}>Dashboard</strong>)}
                    {adminPageActually == 'usuarios' ? (<strong style={{ color: '#1B82FC' }} className={styles.adminPageActually}>Usuários</strong>) : (<strong onClick={navigateToUsers}>Usuários</strong>)}
                    {adminPageActually == 'invitationsManager' ? (<strong style={{ color: '#1B82FC' }} className={styles.adminPageActually}>Convites</strong>) : (<strong onClick={navigateToInvitationsManager}>Convites</strong>)}
                    {adminPageActually == 'enterprises' ? (<strong style={{ color: '#1B82FC' }} className={styles.adminPageActually}>Empresas</strong>) : (<strong onClick={navigateToEnterprises}>Empresas</strong>)}
                </div>
                ) : null}
            </div>
            <div className={styles.column4}>
                <button className={styles.menuButton} onClick={toggleMenu}>
                    <MenuIcon />
                </button>
                {darkMode ? (
                    <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                    {userData && userData.foto ? (
                        <img
                            src={`https://evoktm.com.br/evokchat/fotos_usuarios/${userData.foto}`}
                            alt="Foto do usuário"
                            onClick={adminBI ? null : (adminUser ? navigateToProfileAdmin : navigateToProfile)}
                            style={{ cursor: 'pointer' }}
                        />
                    ) : (
                        <div 
                            className="symbol-label fs-3 bg-primary text-white" 
                            onClick={adminBI ? null : (adminUser ? navigateToProfileAdmin : navigateToProfile)}
                            style={{ cursor: 'pointer' }}
                        >
                            {userData && userData.nome ? userData.nome.slice(0, 2).toUpperCase() : 'N/A'}
                        </div>
                    )}
                </div>
                ) : (
                <div className="symbol symbol-circle symbol-50px overflow-hidden me-3">
                    {userData && userData.foto ? (
                        <img
                            src={`https://evoktm.com.br/evokchat/fotos_usuarios/${userData.foto}`}
                            alt="Foto do usuário"
                            onClick={adminBI ? null : (adminUser ? navigateToProfileAdmin : navigateToProfile)}
                            style={{ cursor: 'pointer' }}
                        />
                    ) : (
                        <div 
                            className="symbol-label fs-3 bg-primary text-white" 
                            onClick={adminBI ? null : (adminUser ? navigateToProfileAdmin : navigateToProfile)}
                            style={{ cursor: 'pointer' }}
                        >
                            {userData && userData.nome ? userData.nome.slice(0, 2).toUpperCase() : 'N/A'}
                        </div>
                    )}
                </div>
                )}
            </div>
        </div>
    );
}
